import { Route } from "react-router-dom";
import RequireAuth from "../Auth/RequireAuth";
import SecuredRoute from "../components/common/VFX-UI/SecuredRoute/SecuredRoute";
import {
    permissions,
} from "../utility/helpers/claimHelper";
import ReportsDashboard from "../components/Dashboard/ReportsDashboard";
import Reports from "../components/Reports/Reports";
import Export from "../components/Exports/Export";
import CampaignsReportsContainer from "../components/Reports/Campaigns/CampaignsContainer";
import CampaignContributionsReportContainer from "../components/Reports/CampaignContribution/CampaignContributionContainer";
import CampaignDesignationReportContainer from "../components/Reports/Employee/CampaignDesignationsReportContainer";

export default (
    <>
        <Route
            path="/reports-page"
            element={
                <RequireAuth>
                    <ReportsDashboard />
                </RequireAuth>
            }
        />
        <Route
            path="/reports"
            element={
                <RequireAuth>
                    <SecuredRoute requiredPermission={permissions.VIEW_REPORTS}>
                        <Reports />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/export"
            element={
                <RequireAuth>
                    <SecuredRoute requiredPermission={permissions.VIEW_EXCEL_REPORTS}>
                        <Export />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route path="/reports/campaigns" element={<CampaignsReportsContainer />} />
        <Route
            path="/reports-page/report-campaign-contributions"
            element={<CampaignContributionsReportContainer />}
        />
        <Route
            path="/reports-page/report-campaign-designations"
            element={<CampaignDesignationReportContainer />}
        />
    </>
);
